var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6551 3.54719L13.4178 2.78445C14.0497 2.15258 15.0742 2.15258 15.7061 2.78445C16.3379 3.41633 16.3379 4.4408 15.7061 5.07268L14.9433 5.83542M12.6551 3.54719L7.52436 8.67789C7.13335 9.06897 6.85596 9.55882 6.72185 10.0953L6.16406 12.3265L8.39522 11.7686C8.93169 11.6346 9.42154 11.3571 9.81263 10.9661L14.9433 5.83542M12.6551 3.54719L14.9433 5.83542",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6397 10.4004C14.6397 12.9333 14.6397 14.1997 13.9402 15.0521C13.8121 15.2081 13.6691 15.3512 13.513 15.4793C12.6606 16.1788 11.3942 16.1788 8.86128 16.1788H8.47613C5.57057 16.1788 4.1178 16.1788 3.21516 15.2762C2.31252 14.3736 2.3125 12.9207 2.3125 10.0152V9.62997C2.3125 7.09712 2.3125 5.8307 3.01203 4.97831C3.1401 4.82226 3.2832 4.67916 3.43924 4.55109C4.29164 3.85156 5.55805 3.85156 8.09091 3.85156",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.a7bc31c231f99bc91f352111fb1f6b15.svg";
export { ForwardRef as ReactComponent };